import $rdf from '@zazuko/env/web.js';
export default class {
    constructor(path, nodeExpression, options = {}) {
        this.path = path;
        this.nodeExpression = nodeExpression;
        this.options = options;
    }
    buildPatterns({ focusNode, objectNode, variable, rootPatterns, builder }) {
        var _a;
        const { patterns, requiresFullContext } = builder.build(this.nodeExpression, { subject: focusNode, object: objectNode, variable, rootPatterns });
        let whereClause;
        let unionPatterns;
        if (((_a = patterns[0]) === null || _a === void 0 ? void 0 : _a.type) === 'query') {
            whereClause = [{
                    type: 'group',
                    patterns: [{
                            ...patterns[0],
                            where: [
                                ...patterns[0].where,
                                ...rootPatterns,
                            ],
                        }],
                }];
        }
        else {
            whereClause = patterns;
            if (requiresFullContext) {
                whereClause = [...rootPatterns, ...patterns];
            }
        }
        const constructClause = !this.options.inverse
            ? [$rdf.quad(focusNode, this.path, objectNode)]
            : [$rdf.quad(objectNode, this.path, focusNode)];
        return {
            constructClause,
            whereClause,
        };
    }
}
